export default __webpack_public_path__ + "static/ebook-5step-b73823e74a0d7755cbe837811f2f9567.png";